import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["title", "keywords", "priceInput", "couponsInput", "result", "price", "summary", "tips"];
  static values = { url: String };

  connect() {
    this.timer = null;
  }

  debounce() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.suggest(), 600);
  }

  async suggest() {
    const title = this.titleTarget?.value?.trim();
    if (!title || title.length < 3) return;

    const params = new URLSearchParams({
      title,
      keywords: this.keywordsTarget?.value || ""
    });

    try {
      const response = await fetch(`${this.urlValue}?${params}`, {
        headers: { Accept: "application/json" }
      });
      if (!response.ok) return;
      const data = await response.json();
      this.render(data);
    } catch (e) {
      console.error("AI pricing error", e);
    }
  }

  render(data) {
    this.priceTarget.textContent = data.suggested_price;
    this.summaryTarget.textContent = `${data.treatment} · ${data.city || ""} · ${data.confidence} confidence · n=${data.sample_size}`;
    this.tipsTarget.innerHTML = (data.tips || []).map(t => `<li>• ${t}</li>`).join("");
    this.resultTarget.classList.remove("hidden");
    this._data = data;
  }

  apply() {
    if (!this._data) return;
    if (this.hasPriceInputTarget) this.priceInputTarget.value = this._data.suggested_price;
    if (this.hasCouponsInputTarget) this.couponsInputTarget.value = this._data.coupons_suggested;
  }
}
